export default "__VITE_ASSET__DmeJrOzz__"